import {InlineMenuHelpers} from "shared/UI/UIKit/Menu";

export const getDividerItem = InlineMenuHelpers.getDividerMenuItem;